import { permissions } from "../../permissions";
import { checkUserPermissions } from "@surgia/utils";

export const BranchDetailTabs = [
    {
      key: "general",
      label: "admin.tenantDetails.tabs.generalInfo",
    },
    ...(checkUserPermissions([permissions.VIEW_BRANCH_USERS]) ? [{
      key: "users",
      label: "admin.tenantDetails.tabs.users",
    }] : []),
    ...(checkUserPermissions([permissions.VIEW_DRAFT_PURCHASE_REQUEST]) ? [{
      key: "purchase-requests",
      label: "admin.tenantDetails.tabs.purchaseRequests",
    }] : []),
    
  ];